import { Announcement } from 'ui/announcement';
import { PROJECT_VOCABULARY_NOT_READY_BANNER_BOLD_TEXT } from '../constants';
import { BoldInLineText } from './Styled';

export const PendingAnnouncement = () => {
  return (
    <Announcement>
      <BoldInLineText>{`${PROJECT_VOCABULARY_NOT_READY_BANNER_BOLD_TEXT} `}</BoldInLineText>
    </Announcement>
  );
};
